import type { TObjectDeleteJob } from 'types/objectJob.type';
import { Typography } from '@timeedit/ui-components';
import { Spin } from '@timeedit/ui-components/antd';
import useErrorTableData from '../hooks/useErrorTableData';
import JobErrorTable from './JobErrorTable';
import './JobExecutionResult.scss';

type Props = {
  job: TObjectDeleteJob;
};

const DeleteJobExecutionResult: React.FC<Props> = (props: Props) => {
  const inProgress = ['QUEUED', 'RUNNING'].includes(props.job.status);
  const summary = props.job.summary;
  const errorData = useErrorTableData(props.job);

  return (
    <>
      <div className="job-execution-result-title">
        <Typography.Title level={4}>Result</Typography.Title>
      </div>

      {inProgress && (
        <div className="job-execution-result-box">
          <Spin /> <Typography.Text>Deletion in progress</Typography.Text>
        </div>
      )}
      {!inProgress && (
        <div className="job-execution-result-box">
          <table>
            <tbody>
              <tr>
                <td>
                  <Typography.Text>Deleted objects:</Typography.Text>
                </td>
                <td>
                  <Typography.Text strong>
                    {summary.successful}/{summary.total}
                  </Typography.Text>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography.Text>Failed deletions:</Typography.Text>
                </td>
                <td>
                  <Typography.Text strong>{summary.failed}</Typography.Text>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      <JobErrorTable data={errorData} title="Failed deletions" />
    </>
  );
};

export default DeleteJobExecutionResult;
